<template>
  <div class="warp warp-container">
    <div class="form-inline">
      <div>
        <el-form :inline="true" :model="formInline">
          <el-form-item>
            <el-select
              v-model="formInline.sales"
              placeholder="商务负责人"
              @change="changeSales"
              filterable
            >
              <el-option label="全部商务负责人" value=""></el-option>
              <el-option
                v-for="(item, index) in salesOptions"
                :key="index"
                :label="item.userName"
                :value="item.userGUID"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formInline.CustomerName"
              placeholder="客户名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formInline.ProjectTotalName"
              placeholder="项目名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="formInline.ProjectNo"
              placeholder="项目编号"
              @input="toUpperCase"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button icon="el-icon-plus" @click="showCustomDialog = true"
          >新增客户</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="showDialog = true"
          >新增项目</el-button
        >
      </div>
    </div>

    <el-table
      style="width: 100%; min-height: 400px"
      v-loading="tableLoading"
      row-key="id"
      :data="projectData"
      @row-click="handleRowClick"
      size="medium"
      :max-height="tableHeight"
    >
      <el-table-column label="项目编号" width="180">
        <template slot-scope="scope"> FW{{ scope.row.projectNo }} </template>
      </el-table-column>
      <el-table-column prop="projectTotalName" label="项目名称">
      </el-table-column>
      <el-table-column label="项目类型" width="120">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.projectType === 35"
            >新增</el-tag
          >
          <el-tag type="warning" v-else>续约</el-tag>
        </template></el-table-column
      >
      <el-table-column prop="customerName" label="客户名称"></el-table-column>
      <el-table-column label="项目负责人" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.receiveName">
            {{ scope.row.receiveName }}
          </span>
          <span v-else> - </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="salesName"
        label="商务负责人"
        width="120"
      ></el-table-column>
      <el-table-column label="预估金额" width="100">
        <template slot-scope="scope">
          {{ scope.row.budget | priceFilter }} ¥
        </template>
      </el-table-column>
      <el-table-column label="预估时间" width="120">
        <template slot-scope="scope">
          {{
            scope.row.dealDate === "1900-01-01 00:00:00"
              ? "-"
              : scope.row.dealDate | TimeFilter
          }}
        </template>
      </el-table-column>
      <el-table-column label="实际金额" width="100">
        <template slot-scope="scope">
          {{ scope.row.actualAmount | priceFilter }}¥
        </template>
      </el-table-column>
      <el-table-column label="归档时间" width="120">
        <template slot-scope="scope">
          {{
            scope.row.proceedsDate === "1900-01-01 00:00:00"
              ? "-"
              : scope.row.proceedsDate | TimeFilter
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="visitCount"
        label="拜访次数"
        width="100"
      ></el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageCurrent"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="elPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotalCount"
      >
      </el-pagination>
    </div>

    <!-- 新增项目 -->
    <el-dialog
      :visible="showCustomDialog"
      title="新增客户"
      width="30%"
      top="10vh"
      ref="addNewCustom"
      @close="handleCustomClose"
    >
      <AddNewCustom :close-dialog="handleCustomClose"></AddNewCustom>
      <!-- 更多配置项... -->
    </el-dialog>

    <el-dialog
      :visible="showDialog"
      title="新增项目"
      width="30%"
      top="10vh"
      @close="handleClose"
    >
      <AddNewProjects :close-dialog="handleClose"></AddNewProjects>
      <!-- 更多配置项... -->
    </el-dialog>
  </div>
</template>
<script>
import { GetProjectManagementPageList } from "@/api/M_ProjectManagement.js";

import { GetUserByDepartList } from "@/api/index.js";
import AddNewProjects from "./components/AddNewProjects.vue";
import AddNewCustom from "./components/AddNewCustom.vue";
export default {
  components: {
    AddNewCustom,
    AddNewProjects
  },
  data() {
    return {
      tableHeight: 0, // 表格高度
      formInline: {
        pageCurrent: 1,
        pageLimit: 30,
        sales: "全部商务负责人",
        CustomerName: "",
        ProjectTotalName: "",
        ProjectNo: ""
      },
      salesOptions: [], // 选择商务负责人下拉框

      tableLoading: false,
      projectData: [
        {
          projectNo: "",
          projectTotalName: "",
          projectType: "",
          customerName: "",
          projectProceedsDate: "",
          taskProceedsDate: "",
          created: ""
        }
      ],

      // pagination底部翻页控件
      pageCurrent: 1,
      pageLimit: 30,
      tableTotalCount: 0,
      elPageSize: 30, // 默认翻页条数

      showCustomDialog: false,
      showDialog: false
    };
  },
  activated() {},
  watch: {},
  created() {},
  computed: {},
  destroyed() {
    // 销毁组件
    sessionStorage.removeItem("searchFlag");
  },
  mounted() {
    // 存在 读缓存
    if (
      sessionStorage.getItem("searchFlag") &&
      sessionStorage.getItem("formInline")
    ) {
      this.formInline = JSON.parse(sessionStorage.getItem("formInline"));
      this.elPageSize = this.formInline.pageLimit;

      // this.fnGetReceiveProjectUserNew();
      this.fnGetReceiveProjectNew();
      this.fnGetUserByDepartList(); // 获取商务负责人选项框
    } else {
      this.formInline.pageLimit = 30;
      this.formInline.pageCurrent = 1;
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem("formInline");

      // this.fnGetReceiveProjectUserNew();
      this.fnGetReceiveProjectNew();
      this.fnGetUserByDepartList(); // 获取商务负责人选项框
    }

    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 220;
    });
  },
  methods: {
    // 获取商务负责人选项框
    fnGetUserByDepartList() {
      GetUserByDepartList({ departId: "710,2792,281,450" })
        .then((res) => {
          // console.log(res.data);
          for (var i = 0; i < res.data.length; i++) {
            this.salesOptions.push({
              userName: res.data[i].userName,
              userGUID: res.data[i].userGUID
            });
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },

    changeSales(val) {
      this.formInline.SalesUserGUID = val;
    },

    // 搜索
    onSubmit() {
      sessionStorage.removeItem("formInline");
      sessionStorage.removeItem("searchFlag");
      this.formInline.pageCurrent = 1;
      this.fnGetReceiveProjectNew();
    },

    // 获取项目列表
    fnGetReceiveProjectNew() {
      this.tableLoading = true;
      let params = {
        page: this.formInline.pageCurrent,
        pageSize: this.formInline.pageLimit,
        CustomerName: this.formInline.CustomerName,
        ProjectTotalName: this.formInline.ProjectTotalName,
        ProjectNo: this.formInline.ProjectNo.replace(/FW/g, ""),
        ChargeUserGUID: this.formInline.ChargeUserGUID, // 项目负责人ID
        Sales: this.formInline.SalesUserGUID // 销售人员ID
        // orderby: ""
      };
      GetProjectManagementPageList(params)
        .then((res) => {
          this.projectData = res.data.data;
          this.tableTotalCount = res.data.totalCount;

          this.$nextTick(() => {
            this.pageCurrent = this.formInline.pageCurrent;
          });
        })
        .catch((err) => {
          console.warn(err);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      // this.pageLimit = val;
      this.formInline.pageLimit = val;
      this.elPageSize = this.formInline.pageLimit;
      this.fnGetReceiveProjectNew();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.formInline.pageCurrent = val;
      this.fnGetReceiveProjectNew();
    },

    // 点击table row
    handleRowClick(row, column, event) {
      sessionStorage.setItem("formInline", JSON.stringify(this.formInline));
      this.$router.push({
        path: this.$route.path + "/detail",
        query: {
          projectId: row.projectId,
          projectNo: row.projectNo,
          projectTotalId: row.projectTotalId,
          receiveUserGUID: row.receiveUserGUID
        }
      });
    },

    // 输入框自动转为大写字母
    toUpperCase(val) {
      const str = val.toUpperCase();
      this.formInline.ProjectNo = str;
    },

    handleCustomClose() {
      this.showCustomDialog = false;
    },

    handleClose() {
      this.showDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.warp-container {
  background-color: #fff;
  padding: 20px;
}
.el-select-dropdown__item:last-child {
  margin-bottom: 20px;
}

::v-deep .el-autocomplete-suggestion__wrap {
  padding-bottom: 40px;
}
.form-inline {
  display: flex;
  justify-content: space-between;
}
</style>
